'use strict'

import {createElements} from "../../functions";
import {CardTypes} from "../../common";
import {changeLangToCurrent} from "../language/langSwitcher";
import gsap from "gsap";

export const addConferenceBuyNow = (card, parent) => {
    const button = createElements('button', [`${card}-card__buy-now_conf`, 'language-string', 'button'], parent, 'beforeend', {
        data: 'data-dictionary',
        value: 'Buy now',
    });

    button.innerHTML = changeLangToCurrent('Buy now');
    button.addEventListener('click', buyNowConfHandleClick);
}

const buyNowConfHandleClick = () => {
    // createBuyNowBlock();
    window.open(config.features.apartments.applyNowLink, '_blank');
    // window.location.href = config.features.apartments.applyNowLink;
}

const createBuyNowBlock = () => {
    const shade = createElements('div', ['buy-now__shade', 'non-canvas'], document.body);
    const container = createElements('div', ['buy-now__container'], document.body);
    createCloseButton(shade);

    buyNowAnimation();

    const iFrameBlock = createElements('iframe', ['buy-now__iframe'], container, 'beforeend', {
        data: 'src',
        value: config.features.apartments.applyNowLink,
    });

    iFrameBlock.setAttribute('target', '_top');
}

const createCloseButton = () => {
    const button = createElements('button', ['buy-now__close-btn', 'icon-close'], document.body);
    button.addEventListener('click', () => {
        document.querySelector('.buy-now__container').remove();
        document.querySelector('.buy-now__shade').remove();
        document.querySelector('.buy-now__close-btn').remove();
    });
}

const buyNowAnimation = () => {
    const tl = gsap.timeline();

    tl
        .fromTo(['.buy-now__shade', '.buy-now__close-btn'], {
            opacity: 0,
        }, {
            opacity: .7,
            duration: .7,
        })
        .fromTo('.buy-now__container', {
            height: '100vh',
            opacity: 0,
        }, {
            opacity: 1,
            height: '90vh',
            duration: .7,
        })
}